import React, { useState, useRef } from 'react';
import { database } from '../../firebase';
import { push, set, ref as dbRef } from 'firebase/database';
import './ImageUploader.scss';

const ImageUploader = () => {
  const [images, setImages] = useState([]);
  const fileInputRef = useRef(null);
  const [isUploading, setIsUploading] = useState(false);


  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    files.forEach((file) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImages((prev) => [...prev, reader.result]);
      };
      reader.readAsDataURL(file);
    });
  };

  const removeImage = (index) => {
    const updatedImages = [...images];
    updatedImages.splice(index, 1);
    setImages(updatedImages);
  };

  const handleUpload = async () => {
    if (images.length === 0) {
      alert('Please upload at least one image.');
      return;
    }
    setIsUploading(true); 
    try {
      const uploadsRef = dbRef(database, 'uploadimages');
      const newUploadRef = push(uploadsRef);
      await set(newUploadRef, {
        images, // Array of Base64 encoded images
        uploadedAt: new Date().toISOString(),
      });

      alert('Images uploaded successfully!');
      setImages([]);
      if (fileInputRef.current) {
        fileInputRef.current.value = '';
      }
    } catch (error) {
      console.error('Error uploading images:', error);
      alert('There was an error uploading your images.');
    }
    finally {
      setIsUploading(false); // End loading
    }
  };

  return (
    <div className="uploader-container">
      <p className="upload-title">Upload your images</p>
    

      <input
        type="file"
        multiple
        accept="image/*"
        onChange={handleImageChange}
        className="file-input"
        ref={fileInputRef}
      />

      <div className="preview-container">
        {images.map((img, idx) => (
          <div key={idx} className="preview-wrapper">
            <img src={img} alt={`preview-${idx}`} className="preview-image" />
            <button className="remove-btn" onClick={() => removeImage(idx)}>
              &#x2716;
            </button>
          </div>
        ))}
      </div>

      <button className="upload-btn" onClick={handleUpload} disabled={isUploading}>
  {isUploading ? 'Uploading...' : 'UPLOAD'}
</button>

    </div>
  );
};

export default ImageUploader;